import React, { Component } from 'react';
import { Card, Col, Row } from 'antd';
import moment from 'moment-timezone';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class PositionDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const position = this.props.position;
        if (!position) return null;

        const timezone = this.props.store.userStore.currentUser.timezone;
        return (
            <Card title={'Position Details'} bordered={false} size={'small'}>
                <Row gutter={24}>
                    <Col md={24}>
                        <b>Position Ref:</b> {position.id} {position.test ? 'TEST POSITION' : ''}
                    </Col>
                    <Col md={24}>
                        <b>Created at:</b>{' '}
                        {moment(position.created_at)
                            .tz(timezone)
                            .format('DD/MM/YYYY hh:mm:ss a')}
                    </Col>
                    <Col md={24}>
                        <b>Closed at:</b>{' '}
                        {position.closed_at
                            ? moment(position.closed_at)
                                  .tz(timezone)
                                  .format('DD/MM/YYYY hh:mm:ss a')
                            : '-'}
                    </Col>
                    <Col md={24}>
                        <b>Auto DCA Level:</b> {position.auto_dca_level || '-'}
                    </Col>
                    <Col md={24}>
                        <b>Auto RT Level:</b> {position.auto_rt_level || '-'}
                    </Col>

                    <Col md={12}>
                        <b>Qty Ordered:</b> {position.amount_ordered}
                    </Col>
                    <Col md={12}>
                        <b>Initial Cost:</b>{' '}
                        {position.initial_cost ? position.initial_cost.toFixed(8) : '-'}{' '}
                    </Col>
                    <Col md={12}>
                        <b>Qty Filled:</b> {position.amount_filled || '-'}
                    </Col>
                    <Col md={12}>
                        <b>Max Cost:</b> {position.max_cost ? position.max_cost.toFixed(8) : '-'}
                    </Col>
                    <Col md={12}>
                        <b>Qty Sold:</b> {position.amount_sold || '-'}
                    </Col>
                    <Col md={12}>
                        <b>Current Value:</b>{' '}
                        {position.curr_value ? position.curr_value.toFixed(8) : '-'}
                    </Col>
                    <Col md={12}>
                        <b>Breakeven Price:</b>{' '}
                        {position.breakeven_price ? position.breakeven_price.toFixed(8) : '-'}
                    </Col>
                    <Col md={12}>
                        <b>Qty Held:</b> {position.amount_held || '-'}
                    </Col>

                    {position.pl ? (
                        <Col md={12}>
                            <b>PNL:</b>
                            &nbsp;
                            <span className={position.pl >= 0 ? 'success' : 'error'}>
                                {position.pl ? position.pl.toFixed(8) : null} (
                                {position.result ? position.result.toFixed(2) : ''}%)
                            </span>
                        </Col>
                    ) : null}

                    <Col md={12}>
                        <b>Avg Buy Price:</b>{' '}
                        {position.avg_buy_price ? position.avg_buy_price : '-'}
                    </Col>
                    <Col md={12}>
                        <b>Fees:</b> {(position.fee_total_in_base || 0).toFixed(8)} (
                        {(position.fees && position.fees.BNB) || '0'} BNB)
                    </Col>
                    <Col md={12}>
                        <b>Avg Sell Price:</b> {position.close_price || '-'}
                    </Col>
                    <Col md={12}>
                        <b>PNL w/ Fees:</b>{' '}
                        <span className={position.pl_w_fees >= 0 ? 'success' : 'error'}>
                            {position.pl_w_fees || '-'} (
                            {position.result_w_fees ? position.result_w_fees.toFixed(2) : ''}%)
                        </span>
                    </Col>
                </Row>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionView/PositionDetails.js